import { render, staticRenderFns } from "./DataGatheringCardList.vue?vue&type=template&id=6690d8cf&scoped=true&"
import script from "./DataGatheringCardList.vue?vue&type=script&lang=js&"
export * from "./DataGatheringCardList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6690d8cf",
  null
  
)

export default component.exports